import { PropsWithChildren } from 'react';

import cn from 'classnames';

type Props = PropsWithChildren<{ className?: string }>;
const FieldLabel = ({ className, children }: Props) => {
    return <h3 className={cn(className, 'text-base font-semibold tracking-tight text-default')}>{children}</h3>;
};

export default FieldLabel;
